import React from "react";
import { useStore } from "../../store";
import PropTypes from "prop-types";
import { Wrapper, EndorsersLogo, EndorserLabel } from "./_styled";
import EndorserCard from "./EndorserCard";

const ContentEndorsers = ({ endorser }) => {
  const { contributorLogos } = useStore();
  const endorserId = endorser?.id?.toLowerCase();

  return (
    <Wrapper data-testid="endorser-wrapper">
      {contributorLogos[endorserId] && (
        <>
          <EndorserLabel
            element="p"
            fontSize="sm"
            marginBottom="sm"
            data-testid="endorser-description"
          >
            <span dangerouslySetInnerHTML={{ __html: endorser.description }} />
          </EndorserLabel>
          <EndorsersLogo
            data-testid="endorser-logo"
            data-endorser-id={endorserId}
            src={contributorLogos[endorserId]?.src}
            alt={contributorLogos[endorserId]?.alt}
          />
        </>
      )}
      {endorserId === "tca" && <EndorserCard />}
    </Wrapper>
  );
};

ContentEndorsers.displayName = "ContentEndorsers";

ContentEndorsers.propTypes = {
  endorser: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default ContentEndorsers;
